<template>
  <div class="text-center">
    <h2 class="txt-head">เพิ่มพนักงาน ด้วยการอัปโหลดไฟล์</h2>
    <v-divider
      class="mx-4"
      inset
      vertical
    ></v-divider>
    <v-layout class="row ml-10">
      <v-col cols="1">
      <p class="txt-font" style="margin-top: 1.5%;">บริษัท</p>
      </v-col>
      <v-col cols="4" class="form-control">
        <v-select
          v-model="formType"
          :items="['INET', 'OGS']"
          item-text="typeName"
          item-value="_id"
          @change="searchSelect(formType)"
          label="เลือก ประเภทเอกสาร"
          dense
          outlined
        ></v-select>
      </v-col>
    </v-layout>
    <v-layout class="row ml-10">
      <v-col cols="1">
      <p class="txt-font" style="margin-top: 1.5%;">เลือกไฟล์</p>
      </v-col>
      <v-col cols="4" class="form-control">
        <v-select
          v-model="formType"
          :items="itemFormType"
          item-text="typeName"
          item-value="_id"
          @change="searchSelect(formType)"
          label="เลือก ประเภทเอกสาร"
          dense
          outlined
        ></v-select>
      </v-col>
    </v-layout>
    <div class="text-right" style="margin-top: 20%;">
    <v-btn class="ma-2 create-orgchart-header-cancel-btn" color="red" dark @click="goback()">ยกเลิก</v-btn>
    <v-btn class="ma-2 create-orgchart-header-cancel-btn" color="success" @click="submitData()">บันทึก
    </v-btn>
    </div>
  </div>
</template>
<script>
export default {
}
</script>
<style scoped>
@import '../../../css/Create.css';
</style>
